import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ApiGetSuccessResponse } from '../models/common/api-get-success-response';
import { Amenity } from '../models/entities/amenity';

@Injectable({
  providedIn: 'root',
})
export class AmenitiesService {
  constructor(private apiService: ApiService) {}

  findAll(): Observable<ApiGetSuccessResponse<Amenity[]>> {
    return this.apiService.get('amenities');
  }
}
